// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderResponse {
    static getAttributeTypeMap() {
        return PharmacyCardFinderResponse.attributeTypeMap;
    }
}
PharmacyCardFinderResponse.discriminator = undefined;
PharmacyCardFinderResponse.additionalProperties = false;
PharmacyCardFinderResponse.attributeTypeMap = [
    {
        "name": "plans",
        "baseName": "plans",
        "type": ""
    },
    {
        "name": "prescriberNpi",
        "baseName": "prescriberNpi",
        "type": "string"
    },
    {
        "name": "transactionCorrelationId",
        "baseName": "transactionCorrelationId",
        "type": "number"
    },
    {
        "name": "transactionDateTime",
        "baseName": "transactionDateTime",
        "type": "Date"
    },
    {
        "name": "transactionId",
        "baseName": "transactionId",
        "type": "string"
    },
    {
        "name": "transactionMessage",
        "baseName": "transactionMessage",
        "type": "string"
    },
    {
        "name": "transactionStatus",
        "baseName": "transactionStatus",
        "type": "boolean"
    },
];
//# sourceMappingURL=pharmacyCardFinderResponse.js.map